import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../../Category/ProductItem';
import Pagination from '../../../hocs/Pagination/Pagination';
import { unique } from '../../../utils/array';
import s from './Products.scss';

const Products = ({ setup, productCache, column = '12', content, attrs = {}, depth = false, isProduct = '' }) => {
	if (!productCache || !productCache[setup.market] || !productCache[setup.market][setup.pricelist] || !content) return null;

	let completeProductList = [];
	const cache = productCache[setup.market][setup.pricelist];

	if (content.individual) {
		completeProductList = [...completeProductList, ...content.individual];
	} else if (content.category) {
		content.category.forEach((category) => {
			// Uses default en
			completeProductList = [...completeProductList, ...(cache.filterArrays.categories[category[setup.language]] ? cache.filterArrays.categories[category[setup.language]] : [])];
		});
	} else if (content.campaign) {
		content.campaign.forEach((campaign) => {
			completeProductList = [...completeProductList, ...(cache.filterArrays.campaigns[campaign] || [])];
		});
	} else if (content.brand) {
		content.brand.forEach((brand) => {
			completeProductList = [...completeProductList, ...cache.filterArrays.brands[brand]];
		});
	}

	completeProductList = unique(completeProductList);
	if (isProduct) completeProductList = completeProductList.filter((cPL) => cPL !== isProduct);
	if (content.limit !== undefined) {
		completeProductList = completeProductList.slice(0, parseInt(content.limit, 10));
	}

	let productsPerRow = content.perRow;
	if (productsPerRow === 'auto') {
		if (completeProductList.length % 6 === 0) productsPerRow = 6;
		else if (completeProductList.length % 5 === 0) productsPerRow = 5;
		else if (completeProductList.length % 4 === 0) productsPerRow = 4;
		else if (completeProductList.length % 3 === 0) productsPerRow = 3;
		else productsPerRow = 4;
	}
	if (!productsPerRow) productsPerRow = 4;

	const classes = [s.products, `productsPerRow_${productsPerRow}`];
	if (attrs.align === 'full') classes[classes.length] = s.products__alignFull;
	if (depth === 1 && attrs.align !== 'full') classes[classes.length] = s.products__top;

	if (content.variation) {
		// if (content.variation.length === 1 && content.variation[0].slice(content.variation[0].indexOf('_') + 1) === 'scroll') classes.push('u_scroll');
		content.variation.forEach((v) => {
			const [size, type] = v.split('_');
			if (type === 'scroll' && (setup.breakPoint === 'desktop' || setup.breakPoint === 'tablet') && size === 'd') classes.push('u_scroll');
			if (type === 'scroll' && setup.breakPoint === 'mobile' && size === 'm') classes.push('u_scroll');
		});
	} else {
		classes.push('u_scroll');
	}

	let imageSize = Math.ceil(column / productsPerRow);
	if (attrs.align === 'full') imageSize = Math.ceil(16 / productsPerRow);
	if (imageSize > 12) imageSize = 'full';

	return (
		<div className={classes.join(' ')}>
			<div className={s.products_inner}>
				<Pagination ListComponent={ProductItem} list={completeProductList} cache={productCache[setup.market][setup.pricelist].products} imageSize={imageSize} currentPath={content.identifier || 'Product Picker'} canonical />
			</div>
		</div>
	);
};

const mapState = ({ environment, productCache }, { content }) => ({
	setup: environment.setup,
	productCache,
	content,
});

export default hot(module)(connect(mapState)(Products));
